// SuppliesSection/index.tsx
import React from "react";
import * as AlfredoComponents from "../../..";
import * as AlfredoStyles from "../../../../styles/components/configuration/sections/suppliesSection/index";
import AlertsAndNotifications from "./AlertsAndNotifications";

interface SuppliesSectionProps {
  selectedVerticalOption: string;
  isEditing: boolean;
  formData: any;
  decryptedInfoToken: any;
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => void;
  handleSave: (objectType: any, payload?: any) => void;
  updateState: (newState: any) => void;
  handleOpenModal: (type: string, object?: any) => void;
}

const SuppliesSection: React.FC<SuppliesSectionProps> = ({
  selectedVerticalOption,
  isEditing,
  formData,
  decryptedInfoToken,
  handleInputChange,
  handleSave,
  updateState,
  handleOpenModal,
}) => {
  switch (selectedVerticalOption) {
    case "SKU":
      return (
        <AlfredoComponents.DynamicTable
          tableType={1}
          handleOpenModal={handleOpenModal}
        />
      );
    // As tabelas 2 e 3 tinham as colunas desenhadas desde sempre e NENHUMA
    // entrada de menu chegava até elas.
    case "Categorias":
      return (
        <AlfredoComponents.DynamicTable
          tableType={2}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Grupos":
      return (
        <AlfredoComponents.DynamicTable
          tableType={3}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Locais de Estoque":
      return (
        <AlfredoComponents.DynamicTable
          tableType={8}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Fornecedores":
      return (
        <AlfredoComponents.DynamicTable
          tableType={4}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Limites de Reposição":
      return (
        <AlfredoComponents.DynamicTable
          tableType={5}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Tipos de Movimentos":
      return (
        <AlfredoComponents.DynamicTable
          tableType={6}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Lista de Materiais":
      return (
        <AlfredoComponents.DynamicTable
          tableType={7}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Alertas e Notificações":
      return (
        <AlertsAndNotifications
          decryptedInfoToken={decryptedInfoToken}
          handleOpenModal={handleOpenModal}
          isEditing={isEditing}
          formData={formData}
          handleInputChange={handleInputChange}
          handleSave={handleSave}
          updateState={updateState}
        />
      );
    default:
      return (
        <div
          style={{
            padding: "var(--sp-40)",
            textAlign: "center",
            color: "#6c757d",
          }}
        >
          <div style={{ fontSize: "var(--fs-6xl)", marginBottom: "var(--sp-16)" }}>📦</div>
          <div style={{ fontSize: "var(--fs-lg)", marginBottom: "var(--sp-8)" }}>
            Sessão não encontrada
          </div>
          <div style={{ fontSize: "var(--fs-md)" }}>{selectedVerticalOption}</div>
        </div>
      );
  }
};

export default SuppliesSection;
